import styled from "styled-components";

export const Container = styled.div`

  .waterAddition {
    box-shadow: none;

    .boxHeaderItemsEvent {
      padding: 0;
      align-items: center;
      display: block;
      margin-bottom: 0;
      margin-top: 12px;

      .content {
        width: 100%;
        display: flex;
        align-items: center;

        .boxHeaderItemsIcon {

          svg {
            width: 33px;
            height: 33px;
          }
        }

        .boxHeaderItemsDescription {
          flex: 1;
          min-width: 0;
          padding-left: 15px;
          display: flex;
          flex-direction: column;

          .heading {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .type {
              padding-right: 10px;
              display: inline-flex;
              align-items: center;
              gap: 6px;
            }
          }

          .typeAndDuration {
            font-weight: 600;
            font-size: 1rem;

            .duration {
              display: flex;
              width: 100px;
              justify-content: flex-end;
            }
          }

          .startDate {
            font-size: 0.8rem;
            color: black;
          }

          .moment {
            font-size: 0.8rem;
            color: black;
          }

        }
      }
    }

  }

  /* highlighted block for post-discharge water reassigned from the previous travel */
  .reassignedBlock {
    margin-top: 16px;
    padding: 10px 12px;
    border: 1.5px dashed #e0a800;
    border-radius: 8px;
    background: #fff7e6;

    .reassignedTitle {
      font-size: 0.8rem;
      font-weight: 700;
      color: #b8860b;
      text-transform: uppercase;
      letter-spacing: 0.4px;
      margin-bottom: 4px;
    }
  }

  /* origin-travel back-reference: post-discharge reused in the NEXT travel (cool tone) */
  .awayBlock {
    border-color: #9aa7b8;
    background: #eef2f7;

    .reassignedTitle {
      color: #4a5a70;
    }
  }

  .badgePost {
    margin-left: 8px;
    padding: 1px 8px;
    border-radius: 12px;
    background: #b8860b;
    color: #fff;
    font-size: 0.6rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    white-space: nowrap;
    flex-shrink: 0;
  }
`;
